import { render, staticRenderFns } from "./FollowModal.vue?vue&type=template&id=a0e0e6ac&"
import script from "./FollowModal.vue?vue&type=script&lang=js&"
export * from "./FollowModal.vue?vue&type=script&lang=js&"
import style0 from "./FollowModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports